import { PropsWithChildren } from "react";
import { DifficultyIndicator } from "components/DifficultyIndicator";
import { IconLabel } from "components/IconLabel";
import { RatingIndicator } from "components/RatingIndicator";
import tourDistanceIcon from "public/icons/tour-distance.svg";
import tourDurationIcon from "public/icons/tour-duration.svg";
import arrowUpIcon from "public/icons/arrow-up.svg";
import arrowDownIcon from "public/icons/arrow-down.svg";
import { formatDuration, formatLength } from "lib/util";

const DetailItem = ({
  title,
  children,
}: PropsWithChildren & { title: string }) => (
  <>
    <dt>{title}</dt>
    <dd className="justify-self-end">{children}</dd>
  </>
);

export const TourDetailSection = ({
  item,
  section,
}: {
  item: Travelguide.Tour;
  section: Travelguide.TourSection.Detail;
}) => (
  <section className="flex flex-col gap-5 w-full md:max-w-xs px-4 md:px-0">
    <h2 className="aside">Tourendetails</h2>
    <p>
      {section.start !== section.end
        ? `Von ${section.start} nach ${section.end}`
        : `Rundtour von ${section.end}`}
    </p>
    <dl className="grid grid-cols-2 items-center text-list font-bold">
      <DetailItem title="Schwierigkeit">
        <IconLabel
          icon={<DifficultyIndicator difficulty={item.rating.difficulty} />}
        >
          {["einfach", "mittel", "schwer"][item.rating.difficulty - 1]}
        </IconLabel>
      </DetailItem>
      <DetailItem title="Strecke">
        <IconLabel icon={tourDistanceIcon}>
          {formatLength(item.distance / 1000, "kilometer")}
        </IconLabel>
      </DetailItem>
      <DetailItem title="Dauer">
        <IconLabel icon={tourDurationIcon}>
          {formatDuration(item.duration)}
        </IconLabel>
      </DetailItem>
      <DetailItem title="Aufstieg">
        <IconLabel icon={arrowUpIcon}>
          {formatLength(item.elevation.ascent, "meter")}
        </IconLabel>
      </DetailItem>
      <DetailItem title="Abstieg">
        <IconLabel icon={arrowDownIcon}>
          {formatLength(item.elevation.descent, "meter")}
        </IconLabel>
      </DetailItem>
      <DetailItem title="Kondition">
        <RatingIndicator
          label="Kondition"
          max={6}
          rating={item.rating.condition}
        />
      </DetailItem>
      <DetailItem title="Erlebnis">
        <RatingIndicator
          label="Erlebnisqualität"
          max={6}
          rating={item.rating.qualityOfExperience}
        />
      </DetailItem>
    </dl>
  </section>
);
